module.exports = __webpack_public_path__ + "img/DW365-335.2c87fb62.jpg";